// Обработчики окна настроек: язык, тема, основной цвет.

import { DEFAULT_DASHBOARD_THEME, THEME_PRESETS } from '../../theme';
import { applyDashboardTheme, applyTheme, changeThemeMode, prefersDarkMedia } from '../theming';
import { changeLocale, currentLocale } from '../locale';
import { closeWidgetMenus, rerenderCachedWidgets } from '../widgets';
import { controls } from '../controls';
import { state } from '../state';

export function bindSettingsEvents(): void {
  controls.settingsFab.addEventListener('click', () => {
    const willOpen = controls.settingsPopover.hidden;
    controls.settingsPopover.hidden = !willOpen;
    controls.settingsFab.setAttribute('aria-expanded', String(willOpen));
  });
  document.addEventListener('click', (event) => {
    const target = event.target as Node;
    if (controls.settingsPopover.hidden) return;
    if (controls.settingsPopover.contains(target) || controls.settingsFab.contains(target)) return;
    controls.settingsPopover.hidden = true;
    controls.settingsFab.setAttribute('aria-expanded', 'false');
  });
  document.addEventListener('click', (event) => {
    const target = event.target as Element;
    if (target.closest('[data-widget-menu]') || target.closest('[data-action="widget-menu"]')) return;
    closeWidgetMenus();
  });
  controls.settingsLocaleRu.addEventListener('click', () => void changeLocale('ru'));
  controls.settingsLocaleEn.addEventListener('click', () => void changeLocale('en'));
  controls.localeToggle.addEventListener('click', () => void changeLocale(currentLocale() === 'en' ? 'ru' : 'en'));
  controls.settingsThemeSystem.addEventListener('click', () => changeThemeMode('system'));
  controls.settingsThemeLight.addEventListener('click', () => changeThemeMode('light'));
  controls.settingsThemeDark.addEventListener('click', () => changeThemeMode('dark'));
  controls.settingsPrimaryColor.addEventListener('input', () => {
    applyDashboardTheme({ primaryColor: controls.settingsPrimaryColor.value });
  });
  controls.settingsResetColors.addEventListener('click', () => applyDashboardTheme(DEFAULT_DASHBOARD_THEME));
  controls.settingsPresets.addEventListener('click', (event) => {
    const button = (event.target as Element).closest<HTMLButtonElement>('[data-theme-preset]');
    if (!button) return;
    const preset = THEME_PRESETS[Number(button.dataset.themePreset)];
    if (preset) applyDashboardTheme(preset);
  });
  prefersDarkMedia.addEventListener('change', () => {
    if (state.preferences.themeMode === 'system') {
      applyTheme();
      void rerenderCachedWidgets(true);
    }
  });
}
